export default {"src":"https://fishbrain.com/_next/static/media/commonCarp.489ad36e.svg","height":115,"width":230,"blurWidth":0,"blurHeight":0};